export function isPremiumPlan(plan) {
  return plan === "Pro" || plan === "Enterprise";
}

/**
 * URL canónica del torneo para QR/cartelería: el HUB público
 * (`/tournamentactions/{slugOrId}`), que es donde el espectador ve el menú
 * "Grupos / Partidos / Bracket / etc.". El viewer de pantalla grande es otra
 * vista y no debe ser el destino del QR del cartel.
 *
 * Acepta o bien un id (string) o bien un objeto con `slug` / `Slug` / `id`.
 */
export function buildTournamentPublicUrl(origin, tournamentOrId) {
  const safeOrigin = typeof origin === "string" && origin.length > 0 ? origin.replace(/\/+$/, "") : "";
  if (!safeOrigin || tournamentOrId == null) return "";

  let pathSegment;
  if (typeof tournamentOrId === "string") {
    pathSegment = tournamentOrId;
  } else if (typeof tournamentOrId === "object") {
    pathSegment =
      tournamentOrId.slug ??
      tournamentOrId.Slug ??
      tournamentOrId.id ??
      tournamentOrId.Id ??
      "";
  } else {
    pathSegment = String(tournamentOrId);
  }
  pathSegment = String(pathSegment || "").trim();
  if (!pathSegment) return "";

  return `${safeOrigin}/tournamentactions/${encodeURIComponent(pathSegment)}`;
}

/**
 * Normalizes a hex color for the qrserver `color`/`bgcolor` params, which expect
 * hex digits without the leading `#`. Returns null for anything invalid.
 */
function qrColorParam(value) {
  if (typeof value !== "string") return null;
  const hex = value.trim().replace(/^#/, "");
  return /^(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(hex) ? hex : null;
}

export function buildQrPreviewUrl(targetUrl, size = 260, options = {}) {
  if (!targetUrl) return "";
  const boundedSize = Number.isFinite(size) ? Math.min(Math.max(Math.floor(size), 120), 800) : 260;
  let url = `https://api.qrserver.com/v1/create-qr-code/?size=${boundedSize}x${boundedSize}&data=${encodeURIComponent(targetUrl)}`;
  const color = qrColorParam(options?.color);
  if (color) url += `&color=${color}`;
  const bgColor = qrColorParam(options?.bgColor);
  if (bgColor) url += `&bgcolor=${bgColor}`;
  return url;
}

